import Auth from "./Auth";
import Private from "./Private";

const Routes = {
  Auth: Auth,
  Private: Private,
};

export default Routes;
